exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kcal-input-mode-radio[data-v-26fe5eea] {\n  margin-left: 60px;\n}", ""]);

// exports
